<!-- <ul class="nav nav-tabs nav-fill size-{{ Size }}" id="{{ tabId }}" role="tablist">
    @for (tab of boxContent; track tab) {
      <li class="nav-item" role="presentation">
        <button
          class="nav-link h4-case"
          [ngClass]="{ active: tab.active }"
          [class.disable]="tab.disabled"
          id="{{ tab.label }}"
          data-bs-toggle="tab"
          [attr.data-bs-target]="'#' + tab.id"
          type="button"
          role="tab"
          aria-controls=""
          (click)="selectedTab.emit(tab.id)"
          area-hidden="true"
          aria-selected="true">
          <span class="h4-case">
            <app-ce-icon
              [name]="tab.icon"
              [svg_class]="['d-flex', 'primary-100']"></app-ce-icon> </span
          ><span class="visually-visible">{{ tab.label }}</span>
        </button>
      </li>
    }
  </ul> -->
<mat-tab-group
  class="tab-header box-tab size-{{ Size }}"
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="onTabChange($event)"
  mat-stretch-tabs>
  <mat-tab *ngFor="let tab of boxContent; let i = index" [disabled]="tab.disabled">
    <ng-template mat-tab-label>
      <span
        class="d-flex align-items-center"
        matTooltip="{{ tab.tooltip }}"
        matTooltipPosition="above">
        <span class="h4-case">
          <app-ce-icon [name]="tab.icon" [svg_class]="['d-flex', 'primary-100']"> </app-ce-icon>
        </span>
        @if (showLabel) {
          <span class="visually-visible h4-case">{{ tab.label }}</span>
        }
      </span>
    </ng-template>
    <ng-container *ngTemplateOutlet="tabTemplates[tab.id]"></ng-container>
  </mat-tab>
</mat-tab-group>
